<template>
    <div class="dynamic" :class="{'dybamicDark':isDark}">
        <div class="articleArr" v-if="data">
            <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="getAggDisByTid"
            >
                <template v-for="(item, index) in data">
                    <div :key="index" @click="goPostDetails(item.id)">
                        <div class="item" v-if="item.plate_id == 200">
                            <div class="left">
                                <div class="title">
                                    {{item.title}}
                                </div>
                                <div class="imgBox" v-if="item.hot_p.length > 0 && item.hot_p.length != 1">
                                    <img v-for="(is, ink) in item.hot_p" :key="ink" :src="is" alt="">
                                </div>
                                <div class="bottom">
                                    <div class="read">
                                        {{item.clicks}}阅读
                                        <span v-if="item.topic_name">{{item.topic_name}}</span>
                                    </div>
                                    <div class="time">{{item.c_time}}</div>
                                </div>
                            </div>
                            <div class="right" v-if="item.hot_p.length > 0 && item.hot_p.length == 1">
                                <img :src="item.hot_p[0]" alt="">
                            </div>
                        </div>
                        <div class="itemUser" v-else-if="item.plate_id == 7  || item.plate_id == 6  || item.plate_id == 77">
                            <div class="userInfo">
                                <div class="left">
                                    <div class="avatar" @click.stop="goUserDetails(item.author_uid)">
                                        <div class="img">
                                            <img :src="item.author_uid_info.avatar" alt="">
                                        </div>
                                        <div class="authorlevel" v-if="item.author_uid_info.mp_rank">
                                            <img :src="require(`@/assets/img/talent/authorlevel${item.author_uid_info.mp_rank}.png`)" alt="">
                                        </div>
                                    </div>
                                    <div class="text">
                                        <div class="name">
                                            {{item.nickname}}
                                        </div>
                                        <div class="time">
                                            {{item.c_time}} 发布于{{item.plate_name}}
                                        </div>
                                    </div>
                                </div>
                                <div class="right">
                                    <span @click.stop="follow(item)" v-if="item.isFollowed == 0"><van-icon name="plus" />关注</span>
                                    <span @click.stop="follow(item)" v-if="item.isFollowed == 1">已关注</span>
                                </div>
                            </div>
                            <div class="content">
                                <div class="title">
                                    {{item.vote_id != '0' ? "【投票】" : ""}}{{item.title}}
                                </div>
                                <div class="describe">
                                    {{item.dis_content}}
                                </div>
                                <div class="imgBox" v-if="item.hot_p.length > 0">
                                    <img v-for="(is, ink) in item.hot_p" :key="ink" :src="is" alt="">
                                </div>
                                <div class="tabs" v-if="item.topic_name">
                                    {{item.topic_name}}
                                </div>
                            </div>
                            <div class="operation">
                                <div class="iconItem">
                                    <van-icon name="share" />
                                </div>
                                <div class="iconItem">
                                    <van-icon name="chat-o" /><em v-if="item.posts_num > 0">{{item.posts_num}}</em>
                                </div>
                                <div class="iconItem" @click.stop="giveTheThumbsUp(item)">

                                    <van-icon v-if="item.like_mark !== 1" name="good-job-o" />
                                    <van-icon v-else name="good-job" />
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </van-list>
        </div>
    </div>
</template>

<script>
import { getAggDisByTid, getUserFollow, getUserUnfollow, getUserLike } from "@/api/team.js"
import jsbridg from "@/utils/jsbridg.js"
import { isJHApp, doLogin } from "@/utils/base.js"
export default {
    name: 'dynamic',
    data () {
        return {
            data: [],
            team_id: this.$route.query.team_id || 193,
            loading: false,
            finished: false,
            page: 1
        }
    },
    computed: {
        isDark () {
            return this.$store.state.common.isDark
        }
    },
    created () {
        this.getAggDisByTid()
        // window.scrollTo({
        //     top: 0,
        //     behavior: "instant"
        // })
    },
    methods: {
        async giveTheThumbsUp (item) {
            if (item.like_mark * 1 !== 1) {
                const params = {
                    discussion_id: item.id,
                    topic_id: item.id,
                    posts_id: '',
                    board: 'discussions',
                    status: 1
                }
                const res = await getUserLike(params)
                if (res.errno * 1 === 0) {
                    this.$toast("点赞成功")
                    item.like_mark = 1
                } else if (res.errno * 1 === -1) {
                    doLogin()
                } else {
                    this.$toast(res.errmsg)
                }
            }
        },
        async follow (item) {
            if (item.isFollowed * 1 === 0) {
                const res = await getUserFollow({ fuid: item.author_uid })
                if (res.errno * 1 === 0) {
                    this.$toast("关注成功")
                    item.isFollowed = 1
                } else if (res.errno * 1 === -1) {
                    doLogin()
                } else {
                    this.$toast(res.errmsg)
                }
            } else {
                const res = await getUserUnfollow({ fuid: item.author_uid })
                if (res.errno * 1 === 0) {
                    this.$toast("取消成功")
                    item.isFollowed = 0
                } else if (res.errno * 1 === -1) {
                    doLogin()
                } else {
                    this.$toast(res.errmsg)
                }
            }
        },
        goPostDetails (id) {
            if (isJHApp()) {
                jsbridg.goJHpostDetail(id);
            }
        },
        goUserDetails (id) {
            jsbridg.appUserPage(id);
        },
        async getAggDisByTid () {
            this.loading = true
            const parmas = {
                zid: 2,
                cid: 2,
                tid: this.team_id,
                page: this.page++
            }
            const res = await getAggDisByTid(parmas)
            if (res.errno === 0) {
                if (res.data) {
                    if (res.data.record && res.data.record.length > 0) {
                        this.data.push(...res.data.record)
                    } else {
                        this.finished = true
                    }
                } else {
                    this.finished = true
                }
            } else {
                this.$toast(res.errmsg)
            }
            this.loading = false
        }
    }
}
</script>

<style lang="less" scoped>
.dynamic{
    background: #F5F5F5;
    min-height: calc(100vh - 200px);
    .articleArr{
        .item{
            background: #fff;
            margin-bottom: 5px;
            display: flex;
            padding: 12px 14px;
            .left{
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                .title{
                    font-size: 16px;
                    font-weight: 600;
                    color: #333333;
                }
                .imgBox{
                    margin: 10px 0;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    img{
                        width: 113px;
                        height: 88px;
                        border-radius: 2px;
                    }
                }
                .bottom{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    font-size: 11px;
                    font-weight: 400;
                    color: #7D7D7D;
                    .read{
                        display: flex;
                        align-items: center;
                        span{
                            color: #2F90DF;
                            background: #2f95e941;
                            padding: 0 5px;
                            border-radius: 10px;
                            margin-left: 4px;
                        }
                    }
                }
            }
            .right{
                width: 113px;
                margin-left: 14px;
                img{
                    width: 113px;
                    height: 88px;
                    object-fit: cover;
                }
            }
        }
        .itemUser{
            padding: 0 14px;
            background: #fff;
            margin-bottom: 5px;
            .userInfo{
                height: 60px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .left{
                    display: flex;
                    align-items: center;
                    .avatar{
                        width: 35px;
                        height: 35px;
                        margin-right: 5px;
                        position: relative;
                        .img{
                            width:100%;
                            height: 100%;
                            border-radius: 50%;
                            overflow: hidden;
                            img{
                                width:100%;
                                height: 100%;
                                object-fit: cover;
                            }
                        }
                        .authorlevel{
                            position: absolute;
                            bottom: -3px;
                            right: -3px;
                            width: calc(56px / 4);
                            height: calc(64px / 4);
                        }
                    }
                    .text{
                        .name{
                            font-size: 13px;
                            font-weight: 400;
                            color: #333333;
                        }
                        .time{
                            font-size: 10px;
                            font-weight: 400;
                            color: #ACACAC;
                        }
                    }
                }
                .right{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    span{
                        width: 57px;
                        height: 25px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        color: #3399FF;
                        border: 1px solid #3399FF;
                        border-radius: 13px;
                    }
                }
            }
            .content{
                .title{
                    font-size: 16px;
                    font-weight: 600;
                    color: #333333;
                }
                .describe{
                    font-size: 15px;
                    font-weight: 400;
                    color: #333333;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
                .imgBox{
                    margin: 10px 0;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    img{
                        width: 113px;
                        height: 88px;
                        border-radius: 2px;
                    }
                }
                .tabs{
                    display: inline-block;
                    margin-top: 4px;
                    color: #2F90DF;
                    background: #2f95e941;
                    padding: 0 5px;
                    border-radius: 10px;
                    margin-left: 4px;
                }
            }
            .operation{
                display: flex;
                align-items: center;
                justify-content: space-between;
                height: 40px;
                .iconItem{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    em{
                        font-size: 12px;
                        font-weight: 400;
                        color: #171717;
                        margin-left: 4px;
                    }
                }
                i{
                    font-size: 22px;
                    color: #171717;
                }
            }
        }
    }
}
.dybamicDark{
    background-color: #191919;
    min-height: calc(100vh - 200px);
    .articleArr{
        .item{
            background: #191919;
            .left{
                .title{
                    color: #d3d3d3;
                }
                .bottom{
                    color: #595959;
                }
            }
        }
        .itemUser{
            background: #191919;
            .userInfo{
                .left{
                    .text{
                        .name{
                            color: #d3d3d3;
                        }
                    }
                }
            }
            .content{
                .title{
                    color: #d3d3d3;
                }
                .describe{
                    color: #d3d3d3;
                }
            }
            .operation{
                .iconItem em{
                    color: #d3d3d3;
                }
                i{
                    color: #d3d3d3;
                }
            }
        }
    }
}
</style>
